import React, { useEffect, useState } from 'react';
import './Participants.css';
import Tile from '../../Tile/Tile';
import useIsMobile from '../../hooks/useIsMobile';

export default function Participants({ regularParticipantsIds }) {
  const isMobile = useIsMobile(700);
  const isTablet = useIsMobile(1024);

  const [showNavigation, setShowNavigation] = useState(
    regularParticipantsIds.length > isMobile ? 2 : 3,
  );

  const [sliceFirst, setSliceFirst] = useState(0);
  const [sliceLast, setSliceLast] = useState(isMobile ? 2 : 3);

  const handleArrowDownClick = () => {
    if (sliceLast === regularParticipantsIds.length) return;
    setSliceFirst(sliceFirst + 1);
    setSliceLast(sliceLast + 1);
  };

  const handleArrowUpClick = () => {
    if (sliceFirst === 0) return;
    setSliceFirst(sliceFirst - 1);
    setSliceLast(sliceLast - 1);
  };

  useEffect(() => {
    setSliceFirst(0);
    setSliceLast(isMobile ? 2 : 3);
  }, [isMobile, isTablet]);

  useEffect(() => {
    setShowNavigation(regularParticipantsIds.length > (isMobile ? 2 : 3));
  }, [setShowNavigation, regularParticipantsIds]);

  return (
    <div className="participants">
      {showNavigation && sliceFirst !== 0 && (
        <button
          type="button"
          disabled={sliceFirst === 0}
          className="pointer top left"
          onClick={() => handleArrowUpClick()}>
          {isTablet ? '◀' : '▲'}
        </button>
      )}
      {regularParticipantsIds.slice(sliceFirst, sliceLast).map((id, idx) => (
        <div className="participants-tile" key={id}>
          <Tile
            id={id}
            isLast={idx + 1 === sliceLast - sliceFirst}
            hasNextTile={sliceLast !== regularParticipantsIds.length}
          />
        </div>
      ))}
      {showNavigation && sliceLast !== regularParticipantsIds.length && (
        <button
          type="button"
          disabled={sliceLast === regularParticipantsIds.length}
          className="pointer bottom right"
          onClick={() => handleArrowDownClick()}>
          {isTablet ? '▶' : '▼'}
        </button>
      )}
    </div>
  );
}
